import React, { useEffect, useState } from 'react';
import { ButtonUI, DialogUI } from '.';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BackspaceIcon from '@mui/icons-material/Backspace';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { sxConfig } from './interface.style';

const PinCodeLogInDialog = ({ open, handleClose, setLogInData, logInData }) => {
  const isLgUp = useMediaQuery('(min-width:960px)');
  const [pinCode, setPinCode] = useState('');
  const [showPinCode, setShowPinCode] = useState(false);

  useEffect(() => {
    if (!logInData.pinCode) {
      clearAll();
      setShowPinCode(false);
    }
  }, [logInData.pinCode]);

  const handleNumberClick = (number) => {
    const newPinCode = pinCode + number;
    if (newPinCode.length <= 4) {
      setPinCode(newPinCode);
    }
    if (newPinCode.length === 4) {
      setLogInData((prev) => ({
        ...prev,
        pinCode: newPinCode,
      }));
    }
  };

  const clearAll = () => {
    setPinCode('');
  };

  const deleteLast = () => {
    setPinCode((prev) => prev.slice(0, -1));
  };

  const numberKeys = [];
  for (let i = 0; i < 9; i++) {
    numberKeys.push(
      <ButtonUI
        key={i}
        onClick={() => handleNumberClick(i.toString())}
        text={i}
        className={`bg-[#3A4756] ${isLgUp ? 'py-5 text-3xl' : 'py-1 text-2xl'} rounded`}
      />
    );
  }

  numberKeys.push(
    isLgUp ? (
      <ButtonUI
        key="clear"
        onClick={clearAll}
        text="Törlés"
        className={`bg-[#3A4756] ${isLgUp ? 'py-4' : 'py-1'} text-2xl rounded`}
      />
    ) : (
      <div
        className={`bg-[#3A4756] ${isLgUp ? 'py-4' : 'py-1'} text-2xl rounded text-center text-white`}
        key="clear"
        onClick={clearAll}
      >
        <DeleteIcon />
      </div>
    )
  );

  numberKeys.push(
    <ButtonUI
      key="9"
      onClick={() => handleNumberClick('9')}
      text="9"
      className={`bg-[#3A4756] ${isLgUp ? 'py-4' : 'py-1'} text-2xl rounded`}
    />
  );

  numberKeys.push(
    <div
      className={`bg-[#3A4756] ${isLgUp ? 'py-4' : 'py-1'} text-2xl rounded text-center text-white`}
      key="delete"
      onClick={deleteLast}
    >
      <BackspaceIcon />
    </div>
  );

  return (
    <DialogUI
      open={open}
      handleClose={handleClose}
      headerContent="Bejelentkezés"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '500px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px', alignItems: 'center' }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: isLgUp ? '70px' : '50px',
              height: isLgUp ? '70px' : '40px',
              background: '#3A4756',
              color: 'white',
              borderRadius: '8px',
              margin: '5px',
              textAlign: 'center',
              paddingTop: isLgUp ? '0.8rem' : '0rem',
              fontSize: isLgUp ? '2rem' : '1.8rem',
            }}
          >
            {pinCode[index] ? (showPinCode ? pinCode[index] : '*') : ''}
          </Box>
        ))}
        <IconButton onClick={() => setShowPinCode((prev) => !prev)}>
          {showPinCode ? (
            <VisibilityIcon sx={sxConfig.pinCodeVisibilityIcon} />
          ) : (
            <VisibilityOffIcon sx={sxConfig.pinCodeVisibilityIcon} />
          )}
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: isLgUp ? '0.5rem' : '0.2rem',
          marginTop: isLgUp ? '2rem' : '0.5rem',
        }}
      >
        {numberKeys}
      </Box>
    </DialogUI>
  );
};

export default PinCodeLogInDialog;
